// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/users.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/users.proto.
 */
export const file_cortado_v1_users: GenFile = /*@__PURE__*/
  fileDesc("ChZjb3J0YWRvL3YxL3VzZXJzLnByb3RvEgpjb3J0YWRvLnYxIukECgRVc2VyEgoKAmlkGAEgASgJEg0KBWVtYWlsGAIgASgJEhkKDHBob25lX251bWJlchgDIAEoCUgAiAEBEhcKCmZpcnN0X25hbWUYBCABKAlIAYgBARIWCglsYXN0X25hbWUYBSABKAlIAogBARIzCgpjcmVhdGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgDiAEBEhcKCmNyZWF0ZWRfYnkYByABKAlIBIgBARIzCgp1cGRhdGVkX2F0GAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgFiAEBEhcKCnVwZGF0ZWRfYnkYCSABKAlIBogBARIhChRlbWFpbF9zaWduYXR1cmVfaHRtbBgKIAEoCUgHiAEBEjQKC2FyY2hpdmVkX2F0GDIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgIiAEBEhgKC2FyY2hpdmVkX2J5GDMgASgJSAmIAQESNgoNbGFzdF9sb2dpbl9hdBg0IAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBICogBAUIPCg1fcGhvbmVfbnVtYmVyQg0KC19maXJzdF9uYW1lQgwKCl9sYXN0X25hbWVCDQoLX2NyZWF0ZWRfYXRCDQoLX2NyZWF0ZWRfYnlCDQoLX3VwZGF0ZWRfYXRCDQoLX3VwZGF0ZWRfYnlCFwoVX2VtYWlsX3NpZ25hdHVyZV9odG1sQg4KDF9hcmNoaXZlZF9hdEIOCgxfYXJjaGl2ZWRfYnlCEAoOX2xhc3RfbG9naW5fYXQiDgoMR2V0TWVSZXF1ZXN0ImMKDUdldE1lUmVzcG9uc2USHgoEdXNlchgBIAEoCzIQLmNvcnRhZG8udjEuVXNlchIYChBwcm9maWxlX2NvbXBsZXRlGAIgASgIEhgKEGhhc19vcmdhbml6YXRpb24YAyABKAgi5QEKD1VwZGF0ZU1lUmVxdWVzdBIXCgpmaXJzdF9uYW1lGAEgASgJSACIAQESFgoJbGFzdF9uYW1lGAIgASgJSAGIAQESGQoMcGhvbmVfbnVtYmVyGAMgASgJSAKIAQESEgoFZW1haWwYBCABKAlIA4gBARIhChRlbWFpbF9zaWduYXR1cmVfaHRtbBgFIAEoCUgEiAEBQg0KC19maXJzdF9uYW1lQgwKCl9sYXN0X25hbWVCDwoNX3Bob25lX251bWJlckIICgZfZW1haWxCFwoVX2VtYWlsX3NpZ25hdHVyZV9odG1sImYKEFVwZGF0ZU1lUmVzcG9uc2USHgoEdXNlchgBIAEoCzIQLmNvcnRhZG8udjEuVXNlchIYChBwcm9maWxlX2NvbXBsZXRlGAIgASgIEhgKEGhhc19vcmdhbml6YXRpb24YAyABKAhCJlokaHViLWJhY2tlbmQvZ2VuL2NvcnRhZG8vdjE7Y29ydGFkb3YxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * User represents a user in the system
 *
 * @generated from message cortado.v1.User
 */
export type User = Message<"cortado.v1.User"> & {
  /**
   * Unique identifier for the user
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Email address of the user
   *
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * Phone number of the user (optional)
   *
   * @generated from field: optional string phone_number = 3;
   */
  phoneNumber?: string;

  /**
   * First name of the user (optional)
   *
   * @generated from field: optional string first_name = 4;
   */
  firstName?: string;

  /**
   * Last name of the user (optional)
   *
   * @generated from field: optional string last_name = 5;
   */
  lastName?: string;

  /**
   * Created at of the user (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Created by of the user (optional)
   *
   * @generated from field: optional string created_by = 7;
   */
  createdBy?: string;

  /**
   * Updated at of the user (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by of the user (optional)
   *
   * @generated from field: optional string updated_by = 9;
   */
  updatedBy?: string;

  /**
   * User-level email signature HTML (optional)
   *
   * @generated from field: optional string email_signature_html = 10;
   */
  emailSignatureHtml?: string;

  /**
   * Time the user was archived, if inactive
   *
   * @generated from field: optional google.protobuf.Timestamp archived_at = 50;
   */
  archivedAt?: Timestamp;

  /**
   * User ID of the admin who archived this user
   *
   * @generated from field: optional string archived_by = 51;
   */
  archivedBy?: string;

  /**
   * Last successful Supabase sign-in time, if available
   *
   * @generated from field: optional google.protobuf.Timestamp last_login_at = 52;
   */
  lastLoginAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_cortado_v1_users, 0);

/**
 * GetMeRequest is sent to retrieve the current authenticated user
 *
 * @generated from message cortado.v1.GetMeRequest
 */
export type GetMeRequest = Message<"cortado.v1.GetMeRequest"> & {
};

/**
 * Describes the message cortado.v1.GetMeRequest.
 * Use `create(GetMeRequestSchema)` to create a new message.
 */
export const GetMeRequestSchema: GenMessage<GetMeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_users, 1);

/**
 * GetMeResponse contains the current authenticated user's data
 *
 * @generated from message cortado.v1.GetMeResponse
 */
export type GetMeResponse = Message<"cortado.v1.GetMeResponse"> & {
  /**
   * The authenticated user's data
   *
   * @generated from field: cortado.v1.User user = 1;
   */
  user?: User;

  /**
   * Whether the user's profile is complete (has first_name and last_name)
   *
   * @generated from field: bool profile_complete = 2;
   */
  profileComplete: boolean;

  /**
   * Whether the user belongs to at least one organization
   *
   * @generated from field: bool has_organization = 3;
   */
  hasOrganization: boolean;
};

/**
 * Describes the message cortado.v1.GetMeResponse.
 * Use `create(GetMeResponseSchema)` to create a new message.
 */
export const GetMeResponseSchema: GenMessage<GetMeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_users, 2);

/**
 * UpdateMeRequest is sent to update the current authenticated user's profile
 * If the user doesn't exist in the backend database, they will be created.
 *
 * @generated from message cortado.v1.UpdateMeRequest
 */
export type UpdateMeRequest = Message<"cortado.v1.UpdateMeRequest"> & {
  /**
   * First name to update (optional)
   *
   * @generated from field: optional string first_name = 1;
   */
  firstName?: string;

  /**
   * Last name to update (optional)
   *
   * @generated from field: optional string last_name = 2;
   */
  lastName?: string;

  /**
   * Phone number to update (optional)
   *
   * @generated from field: optional string phone_number = 3;
   */
  phoneNumber?: string;

  /**
   * Email (used when creating new user, ignored for updates)
   *
   * @generated from field: optional string email = 4;
   */
  email?: string;

  /**
   * User-level email signature HTML (optional)
   *
   * @generated from field: optional string email_signature_html = 5;
   */
  emailSignatureHtml?: string;
};

/**
 * Describes the message cortado.v1.UpdateMeRequest.
 * Use `create(UpdateMeRequestSchema)` to create a new message.
 */
export const UpdateMeRequestSchema: GenMessage<UpdateMeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_users, 3);

/**
 * UpdateMeResponse contains the updated user data
 *
 * @generated from message cortado.v1.UpdateMeResponse
 */
export type UpdateMeResponse = Message<"cortado.v1.UpdateMeResponse"> & {
  /**
   * The updated user
   *
   * @generated from field: cortado.v1.User user = 1;
   */
  user?: User;

  /**
   * Whether the user's profile is complete (has first_name and last_name)
   *
   * @generated from field: bool profile_complete = 2;
   */
  profileComplete: boolean;

  /**
   * Whether the user belongs to at least one organization
   *
   * @generated from field: bool has_organization = 3;
   */
  hasOrganization: boolean;
};

/**
 * Describes the message cortado.v1.UpdateMeResponse.
 * Use `create(UpdateMeResponseSchema)` to create a new message.
 */
export const UpdateMeResponseSchema: GenMessage<UpdateMeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_users, 4);

